import React from "react";
import empty from "../assets/empty-box.png";
import signal from "../assets/signal.png";

const NoData = ({ msg, sbj }) => {
  return (
    <div className="d-flex flex-column align-items-center ">
      {msg !== "No record found" ? (
        <div className="alert-icon">
          <i className="flaticon-warning icon-5x text-danger"></i>
        </div>
      ) : (
        <img
          src={empty}
          alt="emty box"
          style={{ width: 100, aspectRatio: 1, marginTop: 5, marginBottom: 5 }}
        />
      )}
      <div className="d-flex justify-content-center">
        <p className="mb-10 w-50 text-center">
          {msg === "can't convert null to object"
            ? "It looks like you may not be enrolled in a PCF Thesis, or your record may not be reflected correctly in the system. Please contact the AOO team for assistance."
            : msg}
          {sbj !== "" && " for "}
          <span className="font-weight-bold text-primary">{sbj}</span>
        </p>
      </div>
    </div>
  );
};

export default NoData;
